import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { arrayDataItemSelectors } from "#/entities/dataStructures/array/model/arraySlice";
import { type ArrayStructureViewProps } from "#/entities/dataStructures/array/ui/ArrayStructureView";
import { StructureDisplayLabel } from "#/entities/dataStructures/array/ui/StructureDisplayLabel";
import { MapItem } from "#/entities/dataStructures/map/ui/MapItem";
type MapStructureViewProps = ArrayStructureViewProps;
export const MapStructureView: React.FC<MapStructureViewProps> = t0 => {
  const $ = _c(36);
  const {
    data,
    parentColorMap,
    sx
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== data.nodes) {
    t1 = arrayDataItemSelectors.selectAll(data.nodes);
    $[0] = data.nodes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  const {
    displayLabel
  } = data;
  let t2;
  if ($[2] !== sx) {
    t2 = {
      width: "fit-content",
      ...sx
    };
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== displayLabel) {
    t3 = displayLabel ? <StructureDisplayLabel label={displayLabel} /> : null;
    $[4] = displayLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== theme.palette.primary.light) {
    t4 = alpha(theme.palette.primary.light, 0.3);
    $[6] = theme.palette.primary.light;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `1px solid ${t4}`;
  let t6;
  if ($[8] !== theme.palette.primary.light) {
    t6 = alpha(theme.palette.primary.light, 0.8);
    $[8] = theme.palette.primary.light;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `1px solid ${t6}`;
  let t8;
  if ($[10] !== t7) {
    t8 = {
      border: t7
    };
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t10;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      "& > td:first-of-type": {
        borderTopLeftRadius: "4px"
      },
      "& > td:last-child": {
        borderTopRightRadius: "4px"
      },
      "&::after": {
        borderRadius: "4px 4px 0 0"
      }
    };
    t10 = {
      "& > td:first-of-type": {
        borderBottomLeftRadius: "4px"
      },
      "& > td:last-child": {
        borderBottomRightRadius: "4px"
      },
      "&::after": {
        borderRadius: "0 0 4px 4px"
      }
    };
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== t5 || $[15] !== t8) {
    t11 = {
      width: "fit-content",
      borderCollapse: "separate",
      borderSpacing: 0,
      border: t5,
      borderRadius: "4px",
      "&:hover": t8,
      "& tr:first-of-type": t9,
      "& tr:last-child": t10
    };
    $[14] = t5;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== data.colorMap || $[18] !== items || $[19] !== parentColorMap) {
    let t13;
    if ($[21] !== data.colorMap || $[22] !== parentColorMap) {
      t13 = item => <MapItem key={item.id} item={item} colorMap={data.colorMap ?? parentColorMap} />;
      $[21] = data.colorMap;
      $[22] = parentColorMap;
      $[23] = t13;
    } else {
      t13 = $[23];
    }
    t12 = items.map(t13);
    $[17] = data.colorMap;
    $[18] = items;
    $[19] = parentColorMap;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[24] !== items.length) {
    t13 = items.length === 0 && <tr><Box component="td" sx={{
        width: 44,
        height: 44
      }} /></tr>;
    $[24] = items.length;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <tbody>{t12}{t13}</tbody>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t14) {
    t15 = <Box component="table" sx={t11}>{t14}</Box>;
    $[29] = t11;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15 || $[33] !== t2 || $[34] !== t3) {
    t16 = <Box sx={t2}>{t3}{t15}</Box>;
    $[32] = t15;
    $[33] = t2;
    $[34] = t3;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};